module.exports = __webpack_public_path__ + "static/media/supply-tick.2d0cfea8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/supply-tick.svg
// module id = 1046
// module chunks = 0